export default __webpack_public_path__ + "static/media/38_mobile.5c4f9d5d.jpg";